import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";
import { useLanguage } from "@/context/LanguageContext";

export default function Pricing() {
  const { t } = useLanguage();

  const PACKAGES = [
    { id: "profile", name: "The Profile", sub: t("pricing.p1sub"), price: "$150 USD", features: t("pricing.p1f"), featured: false },
    { id: "crossing", name: "The Crossing", sub: t("pricing.p2sub"), price: "$999 USD", features: t("pricing.p2f"), featured: false },
    { id: "transfer", name: "The Journey", sub: t("pricing.p3sub"), price: "$1150 USD", features: t("pricing.p3f"), featured: true },
  ];

  return (
    <section id="packages" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-40" data-testid="packages-section">
      <Reveal>
        <p className="font-jetbrains text-xs uppercase tracking-[0.35em] text-volt mb-6">{t("pricing.chapter")}</p>
        <h2 className="font-cabinet font-black uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-4xl mb-6">
          {t("pricing.h2a")}<span className="text-volt">{t("pricing.h2b")}</span>
        </h2>
        <p className="text-white/60 text-base md:text-lg max-w-2xl leading-relaxed mb-16 md:mb-24">
          {t("pricing.intro")}
        </p>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {PACKAGES.map((pkg, i) => (
          <Reveal key={pkg.id} delay={i * 0.08} className="h-full">
            <div
              className={`h-full p-8 md:p-12 flex flex-col ${pkg.featured ? "bg-elevated relative" : "bg-obsidian"}`}
              data-testid={`package-card-${pkg.id}`}
            >
              {pkg.featured && (
                <span className="absolute top-0 right-0 bg-volt text-obsidian font-jetbrains text-[10px] uppercase tracking-[0.25em] px-4 py-2">
                  {t("pricing.featured")}
                </span>
              )}
              <p className="font-jetbrains text-xs uppercase tracking-[0.3em] text-white/40 mb-4">{pkg.sub}</p>
              <h3 className={`font-cabinet font-black uppercase text-3xl md:text-4xl tracking-tight ${pkg.featured ? "text-volt" : ""}`}>
                {pkg.name}
              </h3>
              <ul className="mt-8 mb-10 space-y-4 flex-1">
                {pkg.features.map((f) => (
                  <li key={f} className="flex gap-3 text-white/70 leading-relaxed">
                    <span className="text-volt mt-1 shrink-0">—</span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="mb-6">
                {pkg.price && (
                  <p className="font-jetbrains text-2xl font-bold text-volt mb-2" data-testid={`package-price-${pkg.id}`}>
                    {pkg.price}
                  </p>
                )}
                <p className="font-jetbrains text-xs uppercase tracking-[0.25em] text-white/40">
                  {pkg.price ? t("pricing.freeFirst") : t("pricing.tailored")}
                </p>
              </div>
              <button
                onClick={() => scrollTo("#contact")}
                data-testid={`package-cta-${pkg.id}`}
                className={`group w-fit rounded-full font-cabinet font-bold uppercase tracking-wide px-7 py-3.5 flex items-center gap-2 transition-colors duration-300 ${
                  pkg.featured
                    ? "bg-volt text-obsidian hover:bg-white"
                    : "border border-white/25 text-white/80 hover:border-volt hover:text-volt"
                }`}
              >
                {t("pricing.cta")}
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
